import React, { Component } from 'react';
import axios from 'axios';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import Loader from 'react-loader-spinner';
import $ from 'jquery';  

var fs = require('browserify-fs');
const API_URL = process.env.REACT_APP_API_URL;  
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;

class CMSpage extends Component {
   constructor(props) {
    super(props);
  console.log(this.props);
     this.state = {
        loaded: true,
        pagetitle:'',
        loading:true,
        pagedescription:'',
        defaultlang:6,
        languagedata:[],
        bannerimage:'/images/about-banner.jpg',
      }
      
  
    } 
custompage(DefaultLang,slug){
  
  axios.post(`${API_URL}/custompages`, { 

    Slug: slug,
    LanguageId:DefaultLang
      }).then(res => {
        if(res.data.Status == 1)
        {
          console.log( res.data.ResponseData);
          const pagetitle = res.data.ResponseData[0].PageTitle;
          const pagedescription = res.data.ResponseData[0].PageContent;
         
          this.setState({ pagetitle });
          this.setState({ pagedescription });
          this.setState({ loading:false });
          this.setState({ loaded: false });
        }
       
        })
}

 componentWillReceiveProps(nextProps) {

//console.log(nextProps);
  $('html, body').animate({
    scrollTop:0
    }, 1000);
  this.setState({ loaded: true });
  const pathname = nextProps.location.pathname;
  console.log(pathname);
  const slug = pathname.replace(/\//g, '');
  if(slug == "about-us"){
  this.setState({bannerimage:'/images/about-banner.jpg'});
  }else if(slug == "terms"){
  this.setState({bannerimage:'/images/terms-banner.jpg'});
  }else if(slug == "privacy-policy"){
  this.setState({bannerimage:'/images/privacy-banner.jpg'});
  }
   const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});
  this.custompage(DefaultLang,slug);
      this.getlanguage(DefaultLang);

    }
componentDidMount() {
      $('html, body').animate({
    scrollTop:0
    }, 1000);
      
  }

   componentWillMount() {
      
      const pathname = this.props.location.pathname;
  console.log(pathname);
  const slug = pathname.replace(/\//g, '');

    const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});
  this.custompage(DefaultLang,slug);
      this.getlanguage(DefaultLang);
    
  }


getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}
    render() {
         
        let cmd_content = <div>{this.state.pagetitle ? <div dangerouslySetInnerHTML={{__html: this.state.pagedescription}} /> : "" } </div>;

        return(
           <div className="App">
        <Layout languagedata={this.state.languagedata}>
            {this.state.loaded == true ? (    
     
  <div className="divloader"> 
     <Loader 
       type="ThreeDots"
       color="#00BFFF"
       height="100" 
       width="100"
      />      
   </div>
  
  ) : '' }

          <section className="banner inner_banner">
            <div className="bd-example">
              <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src={ IMAGE_URL+this.state.bannerimage } className="d-block w-100" alt={"Swacch Bharat - "+this.state.pagetitle} />
                    <div className="carousel-caption d-none d-md-block">
                      <h1>{this.state.pagetitle}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
            {cmd_content}
            
            <Callusnow languagedata={this.state.languagedata} />
            </Layout>
              </div>
            
       
           
          
  );
    }
}


export default CMSpage;



// WEBPACK FOOTER //
// ./src/component/CMSpage.js